import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ModuleCustomizationForm from './ModuleCustomizationForm';
import ModuleCustomizationFormService from '../services/ModuleCustomizationFormService';

class ModuleCustomizationFormContainer extends Component {
  moduleCustomizationFormService = new ModuleCustomizationFormService();

  render() {
    return (
      <ModuleCustomizationForm
        onSubmit={this.moduleCustomizationFormService.handleSubmit}
        onChange={this.moduleCustomizationFormService.form.setValue}
        onReset={this.moduleCustomizationFormService.form.reset}
        values={this.moduleCustomizationFormService.form.getValues()}
        errors={this.moduleCustomizationFormService.form.errors}
        submitting={this.moduleCustomizationFormService.submit.fetching}
        isDirty={this.moduleCustomizationFormService.form.isDirty}
      />
    );
  }
}

export default observer(ModuleCustomizationFormContainer);
